import menuOpen from "./menuOpen"
export default menuOpen;
